import { PreferencesRepository } from "../../adapters/preferencesRepository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: PreferencesRepository): Interactor {
  return () => present(repository.getPreferences());
}

export type { Interactor };

export { createInteractor };
